import React from 'react'
import './cta.css'
function Cta() {
    return (
        <div className='cta__container'> 
            <div className="cta__content">
                <p>Lorem, ipsum dolor.</p>
                <h3>Lorem ipsum dolor sit amet consectetur, adipisicing elit. Blanditiis, doloremque? </h3>
            </div>
            <div className="cta__btn">
                <button type='button'>get Start</button>
            </div>
        </div>
    )
}

export default Cta
